import qr_scanner from "qr-scanner";
import qr_scanner_worker$002Emin from "../../../node_modules/qr-scanner/qr-scanner-worker.min.js?resource";

export function getScanner() {
    qr_scanner.WORKER_PATH = (window.location.origin + qr_scanner_worker$002Emin);
    return qr_scanner;
}

